<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-17 11:52:42
 * @LastEditTime: 2024-02-29 20:16:08
 * @Description:
 * @FilePath: \website\src\pages\smartService\index.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div>
        <el-carousel class="swiper" height="488px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img width="100%" :src="item" alt="" />
            </el-carousel-item>
        </el-carousel>
        <SubMenu
            class="submenu"
            :menuList="menuList"
            @anchorTo="$anchorTo"
        ></SubMenu>
        <!-- 种植管理 -->
        <div class="plant" id="ss1">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/service-plant-topic.png"
            ></Topic>
            <el-row :gutter="64">
                <el-col :span="12">
                    <div v-for="(item, index) in plantManage" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="content">{{ item.content }}</div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-image
                        src="http://wwwadm.tudouec.com/profile/resource/www_img/service-plant.png"
                    ></el-image>
                </el-col>
            </el-row>
        </div>
        <div class="process">
            <div class="title">系统作业流程</div>
            <el-row>
                <el-col class="first">
                    <div class="number">01</div>
                    <div class="text">管理员APP</div>
                </el-col>
                <el-col class="other" style="left: 196px">
                    <div class="number">02</div>
                    <div class="text">下达周期任务</div>
                </el-col>
                <el-col class="other" :style="{ left: `${196 * 2}px` }">
                    <div class="number">03</div>
                    <div class="text">自动推送植保人员</div>
                </el-col>
                <el-col class="other" :style="{ left: `${196 * 3}px` }">
                    <div class="number">04</div>
                    <div class="text">将完成任务上传APP</div>
                </el-col>
                <el-col class="other" :style="{ left: `${196 * 4}px` }">
                    <div class="number">05</div>
                    <div class="text">APP记录种植全过程</div>
                </el-col>
                <el-col class="other" :style="{ left: `${196 * 5}px` }">
                    <div class="number">06</div>
                    <div class="text">管理员监控生产信息</div>
                </el-col>
            </el-row>
        </div>
        <div class="advantage">
            <div class="title">产品优势</div>
            <el-row :gutter="40">
                <el-col
                    :span="8"
                    v-for="(item, index) in advantageList"
                    :key="index"
                >
                    <el-image
                        :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${item.src}`"
                    ></el-image>
                    <div class="text">
                        <div class="title">{{ item.title }}</div>
                        <div>{{ item.content }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="customer">
            <div class="title">适用人群</div>
            <el-row :gutter="40">
                <el-col
                    :span="8"
                    v-for="(item, index) in customerList"
                    :key="index"
                >
                    <el-image
                        :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${item.src}`"
                    ></el-image>
                </el-col>
            </el-row>
        </div>
        <!-- 产品溯源 -->
        <div class="trace" id="ss2">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/service-trace-topic.png"
            ></Topic>
            <el-row :gutter="64">
                <el-col :span="14">
                    <div v-for="(item, index) in traceAbility" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="content">{{ item.content }}</div>
                    </div>
                </el-col>
                <el-col :span="9" :offset="1">
                    <el-image
                        src="http://wwwadm.tudouec.com/profile/resource/www_img/service-trace.png"
                    ></el-image>
                </el-col>
            </el-row>
        </div>
        <div class="function">
            <div class="title">功能介绍</div>
            <el-row>
                <el-col v-for="(item, index) in functionList" :key="index">
                    <div class="title">{{ item.title }}</div>
                    <div v-html="item.content"></div>
                </el-col>
            </el-row>
            <div class="product">
                <el-row>
                    <el-col :offset="3" :span="8">
                        <div class="title">国家追溯体系无缝对接</div>
                        <div>
                            符合国家农产品追溯体系要求，向上兼容国家重要产品追溯系统。
                        </div>
                    </el-col>
                    <el-col :offset="8" :span="8">
                        <div class="title">物联网数据自动采集</div>
                        <div>
                            物联网集成，气象信息、土壤数据、作物生长数据的自动化采集。
                        </div>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                    <el-col>
                        <div class="title">种植全程信息接入</div>
                        <div>
                            作物种植过程的全信息化管理，种植管理数据自动化接入。
                        </div>
                    </el-col>
                    <el-col
                        class="title"
                        style="color: #fff; text-align: center"
                        >产品优势</el-col
                    >
                    <el-col>
                        <div class="title">基于企业视角的流通分析</div>
                        <div>
                            对商品流向进行精准分析，帮助企业把控渠道，防止窜货，把握市场行情。
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 项目案例 -->
        <div class="case" id="ss3">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/service-case-topic.png"
            ></Topic>
            <el-row :gutter="40">
                <el-col
                    :span="8"
                    v-for="(item, index) in caseList"
                    :key="index"
                >
                    <div class="title">{{ item.title }}</div>
                    <el-image
                        :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${item.src}`"
                    ></el-image>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            bannerList: [
                "http://wwwadm.tudouec.com/profile/resource/www_img/banner-smart.png",
            ],
            menuList: [
                { name: "种植管理", anchorId: "ss1" },
                { name: "产品溯源", anchorId: "ss2" },
                { name: "项目案例", anchorId: "ss3" },
            ],
            plantManage: [],
            traceAbility: [],
            advantageList: [],
            customerList: [],
            functionList: [],
            caseList: [],
        };
    },
    methods: {},
    mounted() {
        this.$api.getIntroduceJson("service").then((res) => {
            this.plantManage = res.plantManage;
            this.traceAbility = res.traceAbility;
            this.advantageList = res.advantageList;
            this.customerList = res.customerList;
            this.functionList = res.functionList;
            this.caseList = res.caseList;
        });
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/ .swiper {
    .el-carousel__indicators--horizontal {
        left: 360px;
        bottom: 15%;
    }
}
.plant {
    @extend .topic;
    // padding: 64px inherit;
    margin: 64px 0;
    .title {
        color: $color-main;
        font-size: $font-size-m;
        font-weight: 400;
        line-height: 28px;
    }
    .content {
        font-size: $font-size-m;
        margin-bottom: 32px;
    }
    .el-image {
        height: 306px;
    }
}
.process {
    @extend .topic;
    background-image: url("http://wwwadm.tudouec.com/profile/resource/www_img/service-process-bg.png");
    height: 273px;
    padding-top: 40px;
    * {
        color: #ffffff;
    }
    .title,
    .number {
        font-size: $font-size-xl;
        font-weight: 600;
    }
    .el-row {
        margin-top: 32px;
        position: relative;
        overflow: hidden;
        .first,
        .other {
            background-size: cover;
            width: 218px;
            height: 96px;
            padding: 20px 40px;
        }
        .first {
            background-image: url("http://wwwadm.tudouec.com/profile/resource/www_img/service-process-arrow1.png");
        }
        .other {
            background-image: url("http://wwwadm.tudouec.com/profile/resource/www_img/service-process-arrow2.png");
            position: absolute;
        }
        :last-child {
            width: 235px;
        }
    }
}
.advantage {
    @extend .topic;
    margin: 64px auto;
    .title {
        color: $color-title;
        font-weight: 600;
        font-size: $font-size-xl;
    }
    .el-row {
        margin: 32px;
        .title {
            font-size: $font-size-l;
            line-height: 36px;
        }
        .text {
            height: 173px;
            background-color: #ffffff;
            padding: 32px;
            text-align: center;
        }
    }
}
.customer {
    @extend .topic;
    @extend .advantage;
    .title {
        text-align: left;
    }
    height: 425px;
    padding-top: 40px;
    background-color: #f5f5f5;
    text-align: center;
    .el-image {
        width: 220px;
    }
}
.trace {
    @extend .plant;
    .el-image {
        height: 278px;
    }
}
.function {
    @extend .topic;
    background: url("http://wwwadm.tudouec.com/profile/resource/www_img/service-function-bg.png") no-repeat;
    background-size: 100vw;
    padding-top: 40px;
    .title {
        color: #ffffff;
        font-weight: 600;
        font-size: $font-size-xl;
        margin-bottom: 20px;
    }
    > .el-row {
        margin-top: 32px;
        .el-col {
            width: 217px;
            height: 290px;
            background-color: #ffffff;
            padding: 32px 10px;
            text-align: center;
            line-height: 26px;
            .title {
                color: $color-title;
                font-size: 18px;
            }
            &:hover {
                border-bottom: $color-main solid 3px;
                transform: translateY(-24px);
                .title {
                    color: $color-main;
                }
            }
        }
        .el-col + .el-col {
            margin-left: 24px;
        }
    }
    > .product {
        background: url("http://wwwadm.tudouec.com/profile/resource/www_img/service-fanction-advantage.png")
            no-repeat;
        background-size: 636px;
        background-position: 50% 72px;
        height: 470px;
        margin-top: 64px;
        padding: 102px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        > .el-row {
            .title {
                font-size: $font-size-l;
                color: $color-title;
                margin: 0;
                line-height: 28px;
            }
            .el-col {
                width: 250px;
            }
            :first-child .title {
                text-align: right;
            }
        }
    }
}
.case {
    @extend .topic;
    background-color: #f5f5f5;
    padding: {
        top: 40px;
        bottom: 80px;
    }
    .title {
        background-color: #ffffff;
        text-align: center;
        font-size: $font-size-l;
        line-height: 48px;
        margin-bottom: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/smartService/index.vue